document.addEventListener('DOMContentLoaded', function() {
    const affiliateForm = document.getElementById('affiliate-form');
    
    if (affiliateForm) {
      affiliateForm.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Check if terms are accepted
        const tosCheckbox = document.getElementById('tos');
        if (!tosCheckbox.checked) {
          alert('Please accept the Terms of Service to continue.');
          return;
        }
        
        // Get hCaptcha response
        const hCaptchaResponse = document.getElementById('h-captcha-response').value;
        if (!hCaptchaResponse) {
          alert('Please complete the captcha verification.');
          return;
        }
        
        // Collect form data
        const formData = new FormData(affiliateForm);
        
        // Submit form via fetch API
        fetch('/your-affiliate-endpoint', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            // Show success popup
            document.querySelector('.popup-success-affiliate').click();
          } else {
            // Show error popup
            document.querySelector('.popup-error-affiliate').click();
          }
        })
        .catch(error => {
          console.error('Error:', error);
          // Show error popup
          document.querySelector('.popup-error-affiliate').click();
        });
      });
    }
    
    // Initialize hCaptcha
    if (typeof hcaptcha !== 'undefined') {
      hcaptcha.render('h-captcha', {
        sitekey: '69424386-4c32-46cc-95d0-a962ade4d08a',
        callback: function(response) {
          document.getElementById('h-captcha-response').value = response;
        }
      });
    }
  });